import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-edit-03',
  templateUrl: './edit-03.html',
  styleUrl: './edit-03.scss',
})
export class Edit03 {
  stroke = input<string>('#797674');
  width = input<string>('1rem');
  height = input<string>('1rem');
}
